import { Controller } from "@hotwired/stimulus"

// Diario category filter. Reflects the active chip via aria-pressed and hides
// every entry whose `data-cat` doesn't match. "all" reveals everything.
export default class extends Controller {
  static targets = ["chip", "entry", "empty"]

  set(event) {
    const cat = event.currentTarget.dataset.cat
    this.chipTargets.forEach((c) => {
      c.setAttribute("aria-pressed", c === event.currentTarget ? "true" : "false")
    })
    let visible = 0
    this.entryTargets.forEach((e) => {
      const match = cat === "all" || e.dataset.cat === cat
      e.classList.toggle("hide", !match)
      if (match) visible++
    })
    // Surface the empty-state message when the active category has no entries.
    if (this.hasEmptyTarget) {
      this.emptyTarget.classList.toggle("hidden", visible > 0)
    }
  }
}
